import React from 'react';
import { Link } from 'react-router-dom';

import { Box, ListItem, ListItemIcon, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import i18n from 'i18n-js';

import { Text } from 'components/shared';
import { useStyles } from '../styles';
import { useAppSelector } from 'index';
import { theme } from 'config/theme';

interface NavbarListItemProps {
    isOpen: boolean;
    title: string;
    icon: string | React.ReactNode;
    path: string;
    matches?: string[];
    isButton?: boolean;
    onClick?: () => void;
    color?: string;
}

export default function NavbarListItem(props: NavbarListItemProps) {
    const classes = useStyles();
    const location = useAppSelector((state) => state.router.location.pathname);
    const styles = props.isButton ? { border: 'none', backgroundColor: 'transparent' } : {};
    const color = props.color || theme.palette.primary.dark;
    return (
        <Box className={classes.navbarItem}>
            <ListItem
                className={clsx({
                    [classes.tabActive]: !!props.matches
                        ? props.matches.some((x) => location.includes(x))
                        : location === props.path,
                })}
                style={styles}
                component={props.isButton ? 'button' : Link}
                to={props.isButton ? undefined : props.path}
                onClick={props.isButton ? props.onClick : undefined}
                key={props.path.slice(1)}
            >
                <Tooltip
                    title={props.title}
                    placement="bottom-start"
                    disableHoverListener={props.isOpen}
                >
                    <ListItemIcon>
                        {typeof props.icon === 'string' ? (
                            <Box
                                style={{
                                    backgroundImage:
                                        typeof props.icon === 'string'
                                            ? `url(${props.icon})`
                                            : undefined,
                                }}
                                className={classes.imageContainer}
                            ></Box>
                        ) : (
                            <Box color={color}>{props.icon}</Box>
                        )}
                    </ListItemIcon>
                </Tooltip>
                {/*<ListItemText primary={props.title} />*/}
                <Text
                    text={props.title}
                    className={classes.listItemText}
                    fontSize={14}
                    maxLength={i18n.locale === 'de' ? 20 : 25}
                    withoutMore
                />
            </ListItem>
        </Box>
    );
}
